import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ModelAnnoucementCampaign, ModelDetail, ModelList } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'models',
    events: {
        'Load Model List': emptyProps(),
        'Load Model List Success': props<{ modelList: ModelList }>(),
        'Load Model List Failure': props<{ error: string }>(),

        'Load Model Detail': props<{ slug: string }>(),
        'Load Model Detail Success': props<{ model: ModelDetail }>(),
        'Load Model Detail Failure': props<{ error: string }>(),

        'Load Model Annoucement Campaign': emptyProps(),
        'Load Model Annoucement Campaign Success': props<{ campaign: ModelAnnoucementCampaign }>(),
        'Load Model Annoucement Campaign Failure': props<{ error: string }>(),
    },
});
